import type { MiTorneo } from '../datos/index.js'
import { conSigno, puesto, signoDe } from '../formato.js'
import { ir } from '../navegacion.js'

/**
 * Su lugar en la tabla, resumido.
 *
 * Es un bloque y no una fila de la tabla completa porque en el teléfono la
 * tabla entra recortada, y lo primero que se busca al abrirla es la propia
 * línea. Mostrarla suelta y arriba evita el desplazamiento de veinte filas para
 * enterarse de algo que cabe en cuatro números.
 *
 * Vive suelto y no dentro de una pantalla porque lo usan dos: la de hoy, al
 * lado de la mesa, y el resumen del torneo. Es la misma pregunta contestada en
 * los dos lugares, y contestarla distinto en cada uno haría dudar de cuál de
 * los dos números es el bueno.
 */
export function MiPosicion({
  torneo,
  /** El botón a la tabla completa sobra donde la tabla está a un toque. */
  conEnlace = true,
}: {
  torneo: MiTorneo
  conEnlace?: boolean
}) {
  const mi = torneo.mi
  if (!mi) return null

  return (
    <div className="mi-posicion">
      <div className="mi-posicion-puesto">
        <span className="valor">{puesto(mi.posicion)}</span>
        <span className="etiqueta">de {torneo.participantes}</span>
      </div>

      <dl className="mi-posicion-datos">
        <div>
          <dt>Ganadas</dt>
          <dd className="ganadas">{mi.ganadas}</dd>
        </div>
        <div>
          <dt>Perdidas</dt>
          <dd className="perdidas">{mi.perdidas}</dd>
        </div>
        <div>
          <dt>Efectividad</dt>
          <dd className={`efectividad ${signoDe(mi.efectividad)}`}>{conSigno(mi.efectividad)}</dd>
        </div>
        <div>
          <dt>Puntos</dt>
          <dd>{mi.puntosFavor}</dd>
        </div>
      </dl>

      {/* Que la tabla no cuente la ronda que se está jugando es la pregunta que
          más llega a la mesa de control: alguien ganó hace diez minutos y no ve
          el cambio. Decirlo acá cuesta un renglón. */}
      <p className="mi-posicion-nota tenue">
        Al cierre de{' '}
        {torneo.rondasCerradas === 0 ? 'ninguna ronda' : `la ronda ${torneo.rondasCerradas}`}. La
        que se está jugando todavía no cuenta.
      </p>

      {conEnlace && (
        <button
          className="boton secundario"
          onClick={() => ir({ nombre: 'torneo', id: torneo.id, pestana: 'posiciones' })}
        >
          Ver la tabla completa
        </button>
      )}
    </div>
  )
}
